<script lang="ts" setup>
import FormElement from '@/components/FormElement.vue'
import InputSuffix from '@/components/InputSuffix.vue'
import { ref } from 'vue'
import formStore from '@/store/FormStore.ts'
import { ValidatorType } from '@/helper/ValidateDirective.ts'
import projectStore from '@/store/ProjectStore.ts'

const props = defineProps<{
  validator: ValidatorType
}>()

defineExpose({
  validator: props.validator
})

const width = ref<string>(formStore.data.buildingHull.stories[0].width?.toString() || '')
const length = ref<string>(formStore.data.buildingHull.stories[0].length?.toString() || '')
const height = ref<string>(formStore.data.buildingHull.stories[0].ceilingHeight?.toString() || '')

function setWidth(val: string) {
  formStore.data.buildingHull.stories[0].width = val
}

function setLength(val: string) {
  formStore.data.buildingHull.stories[0].length = val
}

function setCeilingHeight(val: string) {
  formStore.data.buildingHull.stories[0].ceilingHeight = val
}

</script>

<template>
  <div id="building-dimensions" class="row form__row">
    <div class="col-md-3">
      <FormElement
        v-validate="projectStore.projectProperties.buildingHull.formValidationRule?.stories.length"
        :error="validator[`buildingHullLength0`]?.error"
        label-key="step_heating_details.label_building_length"
      >
        <InputSuffix
          id="building-hull-length0"
          key="building-hull-length0"
          v-model="length"
          :placeholder="$t('step_heating_details.label_building_length')"
          suffix=" m"
          @update:model-value="setLength"
        />
      </FormElement>
    </div>
    <div class="col-md-3">
      <FormElement
        v-validate="projectStore.projectProperties.buildingHull.formValidationRule?.stories.width"
        :error="validator[`buildingHullWidth0`]?.error"
        label-for="building-width"
        label-key="step_heating_details.label_building_width"
      >
        <InputSuffix
          id="building-hull-width0"
          key="building-hull-width0"
          v-model="width"
          :placeholder="$t('step_heating_details.label_building_width')"
          suffix=" m"
          @update:model-value="setWidth"
        />
      </FormElement>
    </div>
    <div class="col-md-3">
      <FormElement
        v-validate="projectStore.projectProperties.buildingHull.formValidationRule?.stories.ceilingHeight"
        :error="validator[`buildingHullCeilingHeight0`]?.error"
        label-key="step_heating_details.label_building_height"
      >
        <InputSuffix
          id="building-hull-ceiling-height0"
          key="building-hull-ceiling-height0"
          v-model="height"
          :placeholder="$t('step_heating_details.label_building_height')"
          suffix=" m"
          @update:model-value="setCeilingHeight"
        />
      </FormElement>
    </div>
  </div>
</template>
